import CustomModal from '../../modals';
import { deleteMeetingThunk } from '../../../redux/thunks/calendar';
import { red } from '@mui/material/colors';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

const DeleteMeetingModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { currentUser } = useSelector((state: RootState) => state.app);
    const { selectedCustomer } = useSelector((state: RootState) => state.customer);
    const { loaders, selectedEvent } = useSelector((state: RootState) => state.calendar);

    const deleteMeetingHandler = async () => {
        try {
            let user_id = 0;
            if (id && currentUser?.role !== 'client') {
                user_id = selectedCustomer?.id || 0;
            } else {
                user_id = currentUser?.id as number;
            }
            // await dispatch(deletePipelineThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
            // Close the modal after successful deletion
            await dispatch(deleteMeetingThunk({
                user_id,
                event_id: selectedEvent?.id as number
            })).unwrap();
            onClose();
        } catch (e) {
            // Catch Errors
        }
    };

    return <CustomModal open={open} handleClose={loaders.isDeleting ? () => null : onClose} isError={true} title="Delete Calendar Link">
        <Typography variant="body1" align="center" mb={2}>Are you sure you want to delete this Event with name &quot;<Typography component="span" variant="body1" color={red[300]}>{selectedEvent?.event_name}</Typography>&quot;?</Typography>
        {/* Action buttons */}
        <Box display="flex" gap={2} mt={2}>
            <Button variant="outlined" color="error" onClick={onClose} fullWidth disabled={loaders.isDeleting}>
                Cancel
            </Button>
            <Button type="submit" variant="contained" color="error" onClick={deleteMeetingHandler} fullWidth disabled={loaders.isDeleting}>
                {loaders.isDeleting ? 'Deleting...' : 'Delete'}
            </Button>
        </Box>
    </CustomModal>;
};

export default DeleteMeetingModal;